module.exports = __webpack_public_path__ + "img/dfwvga_lao.47811b07.png";